/**
 * @Name api请求地址常量定义层
 * @提示: 如果发现你定义的接口常量，在你使用时候不对，哪么有可能你定义的名称跟别人冲突呢
 */
import * as commonApis from './apis/commonApis'
import * as homeApis from './apis/homeApis'
import * as exhiConfigApis from './apis/exhiConfigApis'
import * as personalCenterApis from './apis/personalCenterApis'
import * as travelHotelOrderApi from './apis/travelHotelOrderApi'
import * as mediaApis from './apis/mediaApis' // 媒体相关
import * as switchConfigApis from './apis/switchConfigApis'
import * as registApis from './apis/registApis'
import * as vehicleApis from './apis/vehicleApis'
import * as hotelConfigApis from './apis/hotelConfigApis'

// 多模块API合并,更多模块继续引用添加
let apisArray = [
    commonApis,
    homeApis,
    exhiConfigApis,
    personalCenterApis,
    travelHotelOrderApi,
    mediaApis,
    switchConfigApis,
    registApis,
    vehicleApis,
    hotelConfigApis
]

// 接口上下文根
const host = ''

/**
 * 以下代码如果需要修改，请联系小组长
 */
let apis = {}
let flags = {}
// 校验key定义重复相互覆盖
apisArray.forEach(item => {
    Object.keys(item).forEach(key => {
        if (!flags[key]) {
            flags[key] = key
        } else {
            throw new Error(`【${key}】定义重复啦！！！`)
        }
    })
    apis = {
        ...apis,
        ...item
    }
})

// 校验接口是否有定义重复
const __repeatCheck = obj => {
    let tempObj = {}
    Object.keys(obj).forEach(item => {
        if (tempObj[obj[item]]) {
            throw new Error(`【${obj[item]}】接口定义重复啦！！！`)
        } else {
            tempObj[obj[item]] = 1
        }
    })
}
// 调用接口定义重复方法
__repeatCheck(apis)

// 统一添加host上下文根方法
const __addHostContentUtil = obj => {
    let tempObj = {}
    Object.keys(obj).forEach(item => {
        tempObj[item] = host + obj[item]
    })
    return tempObj
}
// 统一添加host上下文根
apis = __addHostContentUtil(apis)
export default apis
